import { Box, Typography } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { store } from 'store/store';
import Link from '@mui/material/Link';

const TenantRefreshDataNavigator = () => {
  const { defaultUserState, currentTenantCd } = useSelector((state) => state.user);
  const location = useLocation();
  const backTo = location.state?.from || '/bi';

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (defaultUserState) {
        store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_FO, { explicitTenant: false }));
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, [defaultUserState, currentTenantCd]);

  return (
    <Box sx={{ mx: '-60px', px: { xs: 2, sm: 6 }, pt: 4, pb: { xs: 4, sm: 6 } }}>
     <Link
        component={RouterLink}
        to={backTo}
        underline="none"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          width: 'fit-content',
          color: '#2F54A5',
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '600',
          letterSpacing: '0%',
          background: 'none',
          border: 'none',
          padding: 0,
          '&:hover': { color: '#068DF1', textDecoration: 'none', background: 'transparent' }
        }}
      >
        <IconArrowNarrowLeft size={16} />
          Back
      </Link>
      <Typography
          sx={{
            color: '#000',
            fontFamily: 'Rubik',
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '1.5rem',
            letterSpacing: '0.01rem',
            mt: 3,
          }}
      >
        Refresh Status
      </Typography>
      <Outlet />
    </Box>
  );
};

export default TenantRefreshDataNavigator;
